angular.module('content.widgets.eventsWidget', [
  'stack',
  'content.widgets.EventsWidgetController'
])

/**
 * The dcsEventsWidget provides a preview
 * of the eventsWidget item type
 *
 * @class dcsEventsWidget
 * @constructor
 * @module content.widgets.eventsWidget
 * @example
 *   <events-widget
 *     model="model">
 *   </events-widget>
 */
.directive('eventsWidget', [
  function () {
    'use strict';

    return {
      restrict: 'E',
      replace: true,
      scope: {
        stateId: '=',
        model: '='
      },
      templateUrl: function () {
        return 'content/source/content/widgets/eventsWidget/events-widget.html';
      },
      controller: 'EventsWidgetController'
    };
  }
]);
